import urlResolver from 'admin/utils/URLResolver';
import useSWR from 'swr';

export const useBranch = (courseId: CourseId) => {
  const { data, error, isLoading } = useSWR(
    urlResolver.reverse('api:branch', { courseId })
  );

  if (error) {
    console.error(error);
  }

  return {
    data,
    isLoading,
    error,
  };
};
